<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-id-card-alt  text-primary"></i> ID Card</h5>
      </div>
      <hr />
      <div class="row g-3">
           <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id" @change="listData()">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class="col-md-3">
          <label class="form-label" for="inputGroupSelect01">Section<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.sectionID" class="form-select form-select-sm rounded cursor-pointer" role="button" @change="listData()">
            <option selected=""></option>
            <option v-for="(item, index) in
              secList" :key="index" :value="item._id"> {{ item.Name }} </option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="inputName" class="form-label">Student<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List" :key="index" :value="item._id"> {{ item.firstName }} {{ item.lastName }} </option>
          </select>
        </div>
      </div>
      <div class="col-md-9 text-end mt-2">
        <button class="btn btn-sm btn-success me-1" @click="save"> <i class="fas fa-search text-white"></i> Go </button>
        <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
    </div>
  </div>
 <div   v-if="showIdCard && !showBack">
<div class="row mt-5">
<div class="col-md-6">
   <div class="col-md-10 d-flex justify-content-between align-items-center flex-wrap mb-2">
  <div class="d-flex flex-wrap align-items-center">
       <input class="form-control form-control-color me-1" type="color" v-model="Obj1.idCardData.sidebarFooterColor" />
      <input class="form-control form-control-color me-1" type="color" v-model="Obj1.idCardData.nameBgColor1" />
      <input class="form-control form-control-color me-1" type="color" v-model="Obj1.idCardData.nameColor1" />
      <input type="checkbox" class="form-check-input" v-model="Obj1.idCardData.primary" id="primary1" />
       <button class="btn btn-sm btn-darknavy p-1 ms-1"  @click="saveCard('Obj1')"> <i class="fa fa-save"></i> Save </button>
        <button class="btn btn-sm btn-darknavy ms-md-1 ms-auto mt-md-0 mt-1 me-md-0 me-4 p-1" @click="showBack = true"><i class="fas fa-undo-alt"></i> Backside </button>
      </div>
  <div class="d-flex align-items-center ms-2">
    <label class="me-2">
    <input type="radio" v-model="Obj1.idCardData.imageShape" value="square" class="form-check-input me-1" />
    <span>Square</span>
  </label>
  <label>
    <input type="radio" v-model="Obj1.idCardData.imageShape" value="circle" class="form-check-input me-1" />
    <span>Circle</span>
  </label>
   <div class="d-flex align-items-center gap-1 ms-5">
      <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printCard(printSection)"></i>
      <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadCard(printSection)"></i>
    </div>
</div>
</div>
<div class="id-card" ref="printSection" >
  <div class="wave-top top-0">
     <div class="sidebar" :style="{ background: sidebarBg }">
      </div>
  </div>
  <div class="card-content">
     <div class="d-flex align-items-start mt-2 start-a">
            <img :src="getUrl(profile?.Image, logo_default)" alt="Student Photo" class="mt-2 ms-2 avatar-md"   />
            <div class="text-start w-100 mt-2 me-3" >
              <p class="text-center fw-bold  mb-0 me-1">{{ profile.Name }}</p>
              <p class="text-center me-1 small mb-0">{{ profile?.Address }}</p>
            </div>
          </div>
    <img :src="getUrl(profileData.student?.image, profile_default)" :class="[Obj1.idCardData.imageShape === 'circle' ? 'rounded-circle' : 'rounded-0', 'avatar-xl', 'mt-1', 'ms-1']" alt="Student Photo" :style="{ border: '3px solid ' + (Obj1.idCardData.sidebarFooterColor) }" />
     <p class="text-center small mb-0 ms-1">  {{ currentyear }}</p>
    <p class="rounded w-75 ms-5" :style="{ backgroundColor: Obj1.idCardData.nameBgColor1, color: Obj1.idCardData.nameColor1 }"><span class="me-4">{{ profileData.student?.firstName }} {{ profileData.student?.lastName }} </span></p>
     <div class="ms-5 mt-n2">
  <div class="row mb-1 align-items-start" >
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Class</strong></div>
    <div class="col text-start ms-50">
      : {{ clsList.find(cls => cls._id ==  profileData.student?.clsID)?.name || '' }}
      <span v-if="profileData?.Section">
        ({{ secList.find(sec => sec._id == profileData.student?.sectionID)?.Name || '' }})
      </span>
    </div>
  </div>
  <div class="row mb-1 align-items-start" v-if="profileData.student?.dob">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Date of Birth</strong></div>
    <div class="col text-start ms-50">: {{ disDate(profileData.student?.dob) }}</div>
  </div>
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Contact No</strong></div>
    <div class="col text-start ms-50">: {{ profileData.parent?.phone }}</div>
  </div>
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Address</strong></div>
    <div class="col text-start ms-50"><span class="address-wrap">: {{ profileData.parent?.address  }}</span></div>
  </div>
  </div>
  </div>
   <div class="wave-bottom" style="bottom:-65px;">
  <p class="text-end me-2">PRINCIPAL</p>
   <div class="print-footer" :style="{ backgroundColor: Obj1.idCardData.sidebarFooterColor }"></div>
</div>
<div class="footer" :style="{ backgroundColor: Obj1.idCardData.sidebarFooterColor }"></div>
      </div>
</div>
<div class="col-md-6">
    <div class="col-md-10 d-flex justify-content-between align-items-center flex-wrap mb-2">
  <div class="d-flex flex-wrap align-items-start flex-nowrap mb-md-0 mb-n5 mt-md-0 mt-5">
<input class="form-control form-control-color me-1" type="color" v-model="Obj2.idCardData.waveTopColor1" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj2.idCardData.waveTopColor2" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj2.idCardData.waveBottomColor1" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj2.idCardData.waveBottomColor2" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj2.idCardData.nameColor2" />
<input type="checkbox" class="form-check-input mt-2 me-1" v-model="Obj2.idCardData.primary" id="primary2" />
<button class="btn btn-sm btn-darknavy p-1 mt-1"  @click="saveCard('Obj2')"> <i class="fa fa-save"></i> Save </button>
</div><br>
  <div class="d-flex align-items-end ms-2 mt-md-0 mt-n4">
  <label class="me-2">
    <input type="radio" v-model="Obj2.idCardData.imageShape" value="square" class="form-check-input me-1" />
    <span>Square</span>
  </label>
  <label>
    <input type="radio" v-model="Obj2.idCardData.imageShape" value="circle" class="form-check-input me-1" />
    <span>Circle</span>
  </label>
  <div class="d-flex align-items-start gap-1 ms-5 print-id2">
    <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printCard(printcontent)"></i>
    <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadCard(printcontent)"></i>
  </div>
</div>
</div>
<div class="id-card" ref="printcontent">
  <div class="wave-top top-0">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100">
      <path d="M0,80 C80,10 320,120 500,50 L500,0 L0,0 Z" :style="{ fill: Obj2.idCardData.waveTopColor1 }"></path>
      <path d="M0,100 C100,40 300,140 500,60 L500,0 L0,0 Z" :style="{ fill: Obj2.idCardData.waveTopColor2, opacity: 0.9 }"></path>
    </svg>
  </div>
  <div class="card-content">
     <div class="d-flex align-items-start start-a mt-2">
            <img :src="getUrl(profile?.Image, logo_default)" alt="Student Photo" class="mt-1 ms-2 avatar-md"  />
            <div class="text-start w-100 mt-1 me-3" :style="{color: Obj2.idCardData.nameColor2 }">
              <p class="text-center fw-bold  mb-0 me-1">{{ profile.Name }}</p>
              <p class="text-center me-1 small mb-0">{{ profile?.Address }}</p>
            </div>
          </div>
      <img :src="getUrl(profileData.student?.image, profile_default)" :class="[Obj2.idCardData.imageShape === 'circle' ? 'rounded-circle' : 'rounded-0', 'avatar-xl', 'mt-1','ms-1']" alt="Student Photo" :style="{ border: '3px solid ' + (Obj2.idCardData.waveTopColor2) }" />
     <p class="text-center small mb-0 ms-1">  {{ currentyear }}</p>
    <p class="rounded w-75 ms-5" :style="{ backgroundColor: Obj2.idCardData.waveTopColor2, color: Obj2.idCardData.nameColor2 }"><span class="me-4">{{ profileData.student?.firstName }} {{ profileData.student?.lastName }} </span></p>
    <div class="ms-5 mt-n2">
  <div class="row mb-1 align-items-start" >
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Class</strong></div>
    <div class="col text-start ms-50">
      : {{ clsList.find(cls => cls._id ==  profileData.student?.clsID)?.name || '' }}
      <span v-if="profileData?.Section">
        ({{ secList.find(sec => sec._id == profileData.student?.sectionID)?.Name || '' }})
      </span>
    </div>
  </div>
  <div class="row mb-1 align-items-start" v-if="profileData.student?.dob">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Date of Birth</strong></div>
    <div class="col text-start ms-50">: {{ disDate(profileData.student?.dob) }}</div>
  </div>
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Contact No</strong></div>
    <div class="col text-start ms-50">: {{ profileData.parent?.phone }}</div>
  </div>
  </div>
  </div>
  <div class="wave-bottom bottom-0">
    <p class="text-end position-absolute right-a"> PRINCIPAL </p>
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100">
      <path d="M0,60 C150,150 350,-30 500,70 L500,150 L0,150 Z" :style="{ fill: Obj2.idCardData.waveBottomColor1 }"></path>
      <path d="M0,80 C180,160 320,-20 500,90 L500,150 L0,150 Z" :style="{ fill: Obj2.idCardData.waveBottomColor2, opacity: 0.9 }"></path>
    </svg>
  </div>
</div>
</div>
<div class="col-md-6 mt-2">
 <div class="col-md-10 d-flex justify-content-between align-items-center flex-wrap mb-2">
  <div class="d-flex flex-wrap align-items-start flex-nowrap  mb-md-0 mb-n5 mt-md-0 mt-5">
<input class="form-control form-control-color me-1" type="color" v-model="Obj3.idCardData.waveTopColor1" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj3.idCardData.waveTopColor2" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj3.idCardData.waveBottomColor1" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj3.idCardData.waveBottomColor2" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj3.idCardData.nameColor2" />
<input type="checkbox" class="form-check-input mt-2 me-1" v-model="Obj3.idCardData.primary" id="primary3" />
<button class="btn btn-sm btn-darknavy p-1 mt-1"  @click="saveCard('Obj3')"> <i class="fa fa-save"></i> Save </button>
</div><br>
  <div class="d-flex align-items-end ms-2 mt-md-0 mt-n4">
     <label class="me-2">
    <input type="radio" v-model="Obj3.idCardData.imageShape" value="square" class="form-check-input me-1" />
    <span>Square</span>
  </label>
  <label>
    <input type="radio" v-model="Obj3.idCardData.imageShape" value="circle" class="form-check-input me-1" />
    <span>Circle</span>
  </label>
  <div class="d-flex align-items-start gap-1 ms-5 print-id2">
    <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printCard(print3)"></i>
    <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadCard(print3)"></i>
  </div>
</div>
</div>
<div class="id-card" ref="print3">
  <div class="wave-top top-0" style="height:105px;">
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100">
      <path d="M900 120 C100 10 200 150 0 150 L0 50 L400 0 Z" :style="{ fill: Obj3.idCardData.waveTopColor2 }"></path>
      <path d="M-90 0 C300 30 300 200 900 150 L900 50 L500 0 Z"  :style="{ fill: Obj3.idCardData.waveTopColor2 }"></path>
      <path d="M0 120 C800 60 600 200 900 40 L500 0 L0 0 Z"  :style="{ fill: Obj3.idCardData.waveTopColor1 }"></path>
    </svg>
  </div>
  <div class="card-content">
     <div class="d-flex align-items-start start-a mt-2">
            <img :src="getUrl(profile?.Image, logo_default)" alt="Student Photo" class="mt-1 ms-2 avatar-md"  />
            <div class="text-start w-100 mt-1 me-3" :style="{color: Obj3.idCardData.nameColor2 }">
              <p class="text-center fw-bold  mb-0 me-1">{{ profile.Name }}</p>
              <p class="text-center me-1 small mb-0 .ml-2r">{{ profile?.Address }}</p>
            </div>
          </div>
      <img :src="getUrl(profileData.student?.image, profile_default)" :class="[Obj3.idCardData.imageShape === 'circle' ? 'rounded-circle' : 'rounded-5', 'avatar-xxl', 'mt-1', 'ms-1', 'bg-white']" alt="Student Photo" :style="{ border: '5px solid ' + (Obj3.idCardData.waveTopColor1) }" />
      <h2 class="text-center"> {{ profileData.student?.firstName }} {{ profileData.student?.lastName }} </h2>
       <p class="text-center small small-a mt-n2 ms-1">  {{  currentyear }}</p>
      <div class="ms-5 mt-n3">
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Contact No</strong></div>
    <div class="col text-start ms-50">: {{  profileData.parent?.phone }}</div>
  </div>
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap"><strong>Address</strong></div>
    <div class="col text-start ms-50">: {{ profileData.parent?.address }}</div>
  </div>
</div>

  </div>
  <div class="wave-bottom bottom-0">
    <p class="text-end position-absolute right-b"> PRINCIPAL </p>
    <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="d-block w-100 h-100">
       <path d="M0,85 C140,53 320,20 460,150 L0,150 Z" :style="{ fill: Obj3.idCardData.waveBottomColor1 }"></path>
      <path d="M0,80 C106,208 320,40 500,50 L500,150 L0,150 Z" :style="{ fill: Obj3.idCardData.waveBottomColor2 }"></path>
    </svg>
  </div>
</div>
</div>
<div class="col-md-6 mt-2 mb-5">
 <div class="col-md-10 d-flex justify-content-between align-items-center flex-wrap mb-2">
  <div class="d-flex flex-wrap align-items-start flex-nowrap  mb-md-0 mb-n5 mt-md-0 mt-5">
<input class="form-control form-control-color me-1" type="color" v-model="Obj4.idCardData.waveTopColor1" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj4.idCardData.waveTopColor2" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj4.idCardData.waveTopColor3" />
<input class="form-control form-control-color me-1" type="color" v-model="Obj4.idCardData.nameColor2" />
<input type="checkbox" class="form-check-input mt-2 me-1" v-model="Obj4.idCardData.primary" id="primary4" />
<button class="btn btn-sm btn-darknavy p-1 mt-1"  @click="saveCard('Obj4')"> <i class="fa fa-save"></i> Save </button>
</div><br>
  <div class="d-flex align-items-end ms-2 mt-md-0 mt-n4">
     <label class="me-2">
    <input type="radio" v-model="Obj4.idCardData.imageShape" value="square" class="form-check-input me-1" />
    <span>Square</span>
  </label>
  <label>
    <input type="radio" v-model="Obj4.idCardData.imageShape" value="circle" class="form-check-input me-1" />
    <span>Circle</span>
  </label>
  <div class="d-flex align-items-start gap-1 ms-5 print-id2">
    <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printCard(print4)"></i>
    <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadCard(print4)"></i>
  </div>
</div>
</div>
<div class="id-card" ref="print4">
  <div class="wave-top top-0" style="height:25px;">
    <svg viewBox="0 0 390 200" xmlns="http://www.w3.org/2000/svg">
  <path  d="M0 0 L390 0 L390 25 L0 25 Z" :style="{ fill: Obj4.idCardData.waveTopColor1 }"/>
  <g transform="translate(0,48) scale(1,-1)">
    <!-- 1st polygon -->
    <polygon fill="#C62828" points="0,-25 130,-25 108,48 0,48" :style="{ fill: Obj4.idCardData.waveTopColor3 }"/>
    <!--2nd polygon -->
    <polygon fill="#E53935" points="82,-35 151,-35 130,5 60,5" :style="{ fill: Obj4.idCardData.waveTopColor3 }"/>
    <!-- small2nd polygon -->
    <polygon fill="#FFEB3B" points="77,-25 126,-25 110,6 60,6" :style="{ fill: Obj4.idCardData.waveTopColor2 }"/>
    <!-- polygon at start -->
    <polygon fill="#E53935" points="-10,-35 50,-35 30,5 -10,5" :style="{ fill: Obj4.idCardData.waveTopColor3 }"/>
    <polygon fill="#FFEB3B" points="-15,-25 40,-25 25,6 -15,6" :style="{ fill: Obj4.idCardData.waveTopColor2 }"/>
    <!--third polygon-->
    <polygon  points="142,6 194,6 174,36 120,36" :style="{ fill: Obj4.idCardData.waveTopColor2 }"/>
  </g>
</svg>
</div>

  <div class="card-content" style="margin-top:-78px">
     <div class="align-items-start">
            <img :src="getUrl(profile?.Image, logo_default)" alt="Student Photo" class="avatar-sm mt-2 text-center"  />
            <div class="text-start w-100 me-3 mt-n1" :style="{color: Obj4.idCardData.nameColor2 }">
              <p class="text-center fw-bold  mb-0 me-1">{{ profile.Name }}</p>
            </div>
          </div>
      <img :src="getUrl(profileData.student?.image, profile_default)" :class="[Obj4.idCardData.imageShape === 'circle' ? 'rounded-circle' : 'rounded-0', 'avatar-xxl', 'ms-1', 'bg-white']" alt="Student Photo" :style="{ border: '5px solid ' + (Obj4.idCardData.waveTopColor1) }" />
      <h2 class="text-center text-dark"> {{ profileData.student?.firstName }} {{ profileData.student?.lastName }} </h2>
      <div class="d-flex align-items-center ms-4">
  <p class="text-center fw-bold text-white  w-75 p-1" :style="{ backgroundColor: Obj4.idCardData.waveTopColor3 }">
    {{ currentyear }}
  </p>
  <svg height="30" width="30" class="mt-n3">
    <line x1="10" y1="0" x2="10" y2="31"  stroke-width="8" stroke-linecap="round"  :stroke="Obj4.idCardData.waveTopColor3"/>
    <line x1="22" y1="0" x2="22" y2="31" stroke-width="8" stroke-linecap="round"  :stroke="Obj4.idCardData.waveTopColor3"/>
  </svg>
</div>
  <div class="ms-5 mt-n2">
  <div class="row mb-1 align-items-start">
    <div class="col-md-3 col-lg-2 text-start text-nowrap ms-n4"><strong>Contact No :</strong></div>
    <div class="col text-center ms-50">{{ profileData.parent?.phone }}</div>
  </div>
</div>
<p class="text-center small mt-4">+{{ profile.MobileNo }} <br>
  <a href="https://schoolsmanagement.com/" class="text-center text-dark small" target="_blank">WWW.Schoolsmanagement.com</a></p>
  </div>
  <div class="wave-bottom bottom-0" style="height:115px;">
<svg width="100%" height="190" viewBox="0 0 1080 190" xmlns="http://www.w3.org/2000/svg">
  <rect x="0" y="50" width="1080" height="200" :style="{ fill: Obj4.idCardData.waveTopColor3 }"/>
  <polygon points=" 0,50 190,50 120,180 0,180 " :style="{ fill: Obj4.idCardData.waveTopColor1 }" />
  <line x1="200" y1="50" x2="130" y2="185" stroke="#C4C4C4" stroke-width="20"></line>
  <polygon points=" 1080,110 820,110 760,190 1080,190 " :style="{ fill: Obj4.idCardData.waveTopColor2 }" />
  <polygon points=" 780,110 640,110 580,190 720,190 " :style="{ fill: Obj4.idCardData.waveTopColor2 }" />
</svg>
  </div>
</div>
</div>
  </div>
  </div>
  <div v-else-if="showIdCard && showBack" class="col-md-6 mt-3 mb-5">
  <div class="d-flex align-items-center mb-1">
   <div class="d-flex align-items-center gap-1">
     <input class="form-control form-control-color me-1" type="color" v-model="globalColors.schoolColor" />
      <input class="form-control form-control-color me-1" type="color" v-model="globalColors.addressColor"/>
      <button class="btn btn-sm btn-darknavy p-1 mt-1 me-1"  @click="saveBack"> <i class="fa fa-save"></i> Save </button>
     <button class="btn btn-sm btn-darknavy mt-1 text-nowrap" @click="showBack = false"><i class="fas fa-undo-alt"></i> Frontside </button>
      <i class="fa fa-print text-primary cursor-pointer fs-4" role="button" @click="printCard(printBack)"></i>
      <i class="fa fa-download fs-4 cursor-pointer me-5" role="button" @click="downloadCard(printBack)"></i>
    </div>
</div>
<div class="id-card d-flex flex-column justify-content-between" ref="printBack" :style="{ backgroundImage: `url('${getUrl(profile?.loginBnr, loginbanner_default)}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', }" >
  <div class="card-content">
    <div class="d-flex align-items-start mt-2 start-a">
      <img :src="getUrl(profile?.Image, logo_default)" alt="Student Photo" class="mt-2 ms-2 ml-100 avatar-md"/>
       <div class="text-start ms-1 mt-4">
        <p class="text-center fs-5 fw-bold  mb-0 text-nowrap" :style="{ color: globalColors.schoolColor }">{{ profile.Name }}</p>
      </div>
    </div>
  </div> 
  <div class="text-center mb-0">
    <p class="fs-6 fw-semibold mt-10 mb-0" :style="{ color: globalColors.addressColor }">{{ profile?.Address }}</p>
  </div>
</div>
</div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { formatDate, api } from '@/utils/helpers.js';
import { ref, computed, watch } from 'vue'
import html2pdf from "html2pdf.js";
 import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList, profile} = schoolStore();
const Obj = ref({ clsID: "", sectionID: "", studentID: "", })
const List= ref([]) 
const profileData= ref([])
const showIdCard = ref(false)
const showBack = ref(false);
const printSection = ref(null)
 const printcontent = ref(null)
 const printBack = ref(null)
const print3 = ref(null)
const print4 = ref(null)
 const logo_default = "/images/Logo.png"
 const loginbanner_default = "/images/Login-Banner.jpg"
const profile_default="/images/default.png"
const msgObj = ref({ msg: "", role: "", show: false, })
const errors = ref({})
const errors1 = ref({})
const globalColors = ref({ schoolColor: "#000000", addressColor: "#000000" });
const Obj1 = ref({
  name: "student",
  _id: null, 
  idCardData: { name: "idCard1", sidebarFooterColor: "##e73623", nameColor1: "#000000", nameBgColor1: "#f3e54f",
    schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false, }
});
const Obj2 = ref({
  name: "student",
  _id: null,
  idCardData: { name: "idCard2", waveTopColor1: "#2980b9", waveTopColor2: "#478fb3", waveBottomColor1: "#50b3d7", waveBottomColor2: "#2c98ce",
    nameColor2: "#000000", schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false, }
});
const Obj3 = ref({
  name: "student",
  _id: null,
  idCardData: { name: "idCard3", waveTopColor1: "#e72323", waveTopColor2: "#900909", waveBottomColor1: "#7e0707", waveBottomColor2: "#f83030",
    nameColor2: "#000000", schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false, }
});
const Obj4 = ref({
  name: "student",
  _id: null,
  idCardData: { name: "idCard4", waveTopColor1: "#073655", waveTopColor2: "#23e7e3", waveTopColor3: "#1f2d93",
    schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false, }
});
watch(globalColors, (v) => {
  ObjList.forEach(obj => {
    if (obj.value?.idCardData) {
      obj.value.idCardData.schoolColor  = v.schoolColor;
      obj.value.idCardData.addressColor = v.addressColor;
    }
  });
}, { deep: true });
const saveCard = async (active) => {
  try {
    const cards = { Obj1, Obj2, Obj3, Obj4, };
    const current = cards[active]; 
    Object.keys(cards).forEach(key => {
      if (key !== active && current.value.idCardData.primary)
        cards[key].value.idCardData.primary = false;
    });
    const Data = {
      name: current.value.name,
      idCardData: current.value.idCardData,
    };
    msgObj.value.show = false;
    if (current.value._id) {
      await api.put(`/idcards/${current.value._id}`, { _id: current.value._id, ...Data });
      msgObj.value = { msg: "ID Card Updated successfully", role: "success", show: true };
    } else {
      const res = await api.post("/idcards/add", Data);
      current.value._id = res.data._id;
      msgObj.value = { msg: "ID Card Saved successfully", role: "success", show: true };
    }
    for (const key in cards) {
      const card = cards[key].value;
      if (key !== active && card._id) {
        await api.put(`/idcards/${card._id}`, {
          _id: card._id,
          name: card.name,
          idCardData: card.idCardData,
        });
      }
    }
    await getCardBystudent("student");
  } catch (err) {
    msgObj.value = { msg: "Failed to save ID card", role: "danger", show: true };
  }
};
const ObjList = [Obj1, Obj2, Obj3, Obj4]; 
const saveBack = async () => {
  ObjList.forEach(obj => {
    if (!obj.value.idCardData) return;
    obj.value.idCardData.schoolColor  = globalColors.value.schoolColor;
    obj.value.idCardData.addressColor = globalColors.value.addressColor;
  });
  await saveCardAll(); 
};
const saveCardAll = async () => {
  try {
    for (let obj of ObjList) {
      if (!obj.value.idCardData) continue;
      if (obj.value._id) {
        await api.put(`/idcards/${obj.value._id}`, obj.value);
      } else {
        const res = await api.post("/idcards/add", obj.value);
        obj.value._id = res.data?._id;  
      }
    }
    msgObj.value = { msg: "ID cards Updated successfully", role: "success", show: true };
    await getCardBystudent("student");
  } catch (err) { return }
};
const getCardBystudent = async (name) => {
  try {
    const res = await api.get("/idcards/all", { params: { name } });
    const cards = Array.isArray(res.data) ? res.data : [res.data];
    Obj1.value._id = null;
    Obj2.value._id = null;
    Obj3.value._id = null;
    Obj4.value._id = null;
    Obj1.value.idCardData = null;
    Obj2.value.idCardData = null;
    Obj3.value.idCardData = null;
    Obj4.value.idCardData = null;
    cards.forEach((card) => {
      if (card.name === "student" && card.idCardData?.name === "idCard1") {
        Obj1.value = { _id: card._id, name, idCardData: { ...card.idCardData } };
      } else if (card.name === "student" && card.idCardData?.name === "idCard2") {
        Obj2.value = { _id: card._id, name, idCardData: { ...card.idCardData } };
      }
      else if (card.name === "student" && card.idCardData?.name === "idCard3") {
        Obj3.value = { _id: card._id, name, idCardData: { ...card.idCardData } };
      }
      else if (card.name === "student" && card.idCardData?.name === "idCard4") {
        Obj4.value = { _id: card._id, name, idCardData: { ...card.idCardData } };
      }
    });
     if (!Obj1.value.idCardData) {
      Obj1.value.idCardData = { name: "idCard1", sidebarFooterColor: "#e73623", nameColor1: "#000000", nameBgColor1: "#f3e54f",
        schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false };
    }
    if (!Obj2.value.idCardData) {
      Obj2.value.idCardData = { name: "idCard2", waveTopColor1: "#2980b9", waveTopColor2: "#478fb3", waveBottomColor1: "#50b3d7", waveBottomColor2: "#2c98ce",
        nameColor2: "#000000", schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false };
    }
    if (!Obj3.value.idCardData) {
      Obj3.value.idCardData = { name: "idCard3", waveTopColor1: "#e72323", waveTopColor2: "#900909", waveBottomColor1: "#7e0707", waveBottomColor2: "#f83030",
        nameColor2: "#000000", schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false };
    }if (!Obj4.value.idCardData) {
      Obj4.value.idCardData = { name: "idCard4", waveTopColor1: "#073655", waveTopColor2: "#23e7e3", waveTopColor3: "#1f2d93",
        schoolColor: "#000000", addressColor: "#000000", imageShape: "circle", primary: false };
    }
     globalColors.value.schoolColor  = Obj1.value.idCardData?.schoolColor  || Obj2.value.idCardData?.schoolColor || Obj3.value.idCardData?.schoolColor || Obj4.value.idCardData?.schoolColor
    globalColors.value.addressColor = Obj1.value.idCardData?.addressColor || Obj2.value.idCardData?.addressColor || Obj3.value.idCardData?.addressColor || Obj4.value.idCardData?.addressColor
  } catch (err) {
    console.error("Failed to fetch ID card data:", err);
  }
};
const sidebarBg = computed(() => {
  const color = Obj1.value.idCardData.sidebarFooterColor.replace('#', '%23');
return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='500'><polygon points='0,0 30,0 5,500 0,500' style='fill:${color};stroke:white;'/></svg>") no-repeat`;
});
const currentyear = computed(() => {
  const today = new Date();
  const month = today.getMonth(); 
  const year = today.getFullYear();
  if (month >= 5) { return `${year}-${year + 1}`; } 
  else { return `${year - 1}-${year}`; }
});
const downloadCard = (refEl) => {
    const element = refEl;
  if (!element) { return; }
  const opt = {
    margin: [5, 15, 5, 5], 
    filename: 'student-id.pdf',
    image: { type: 'jpeg', quality: 1 }, 
    html2canvas: { scale: 4, useCORS: true, allowTaint: true, backgroundColor: null },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };
  html2pdf().set(opt).from(element).save();
}
const printCard = (refEl) => {
  const content = refEl;
  if (!content) { return; }
  content.classList.add("print-only");
  window.print();
  setTimeout(() => {
    content.classList.remove("print-only");
  }, 500); 
};
const disDate= (d)=> { return formatDate(d) }
const listData= async()=> {
      const fields = {
        clsID: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], }
      };
      errors1.value = validateForm(fields);
      if (Object.keys(errors1.value).length === 0) {
        await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`)
        .then((res) => { List.value = res.data });
      }
    }
const save= async()=> {
    const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired], },
    Section: { value: Obj.value.sectionID, validators: [isRequired], },
    Student: { value: Obj.value.studentID, validators: [isRequired], }
  };
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
  await api.get(`/students/${Obj.value.studentID}`)
    .then((res) => {
      profileData.value = res.data
      showIdCard.value = true;
    });
await getCardBystudent("student");
}
}
const reset= async()=> {
  Obj.value = { Class: "", Section: "", Student: "", };
  msgObj.value = { msg: "", role: "", show: false, };
  errors.value={};
  List.value = []; 
  showIdCard.value = false;
  showBack.value = false;
}
   const getUrl = (img, fallback) => {
  let imgUrl = !img
    ? fallback
    : img.startsWith("..")
      ? img.substring(2)
      : img;
  
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
</script>